/**
 * Created by JasonChou on 17/6/19.
 */
import React, {PureComponent} from 'react'

export default class Image extends PureComponent {

    getElm() {
        return this.refs.raw
    }

    render() {
        const {source, style, ...other} = this.props;

        if (isNetImage(source) && style)
            source.uri = imageCut(source.uri, style);

        return <div style={Object.assign({
            backgroundSize: 'cover',
            backgroundImage: 'url(' + (source.uri || source) + ')',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
        }, style)} {...other}
                    ref={'raw'}
                    alt="="/>;
    }
}

export const imageCut = function (url, {width, height}) {

    if (url.match(/\?/)) //有参数的一律不处理
        return url;

    let density = 2;

    width = Math.floor(width);
    height = Math.floor(height);

    if (height && width)
        return url + `?imageView2/1/w/${width * density}/h/${height * density}`

    url += '?imageView2/2';

    if (width)
        url += `/w/${width * density}`;
    else if (height)
        url += `/h/${height * density}`;

    return url;
}


function isNetImage(source) {
    if (source && source.uri && ( source.uri.startsWith("https://") || source.uri.startsWith("http://") )) {
        return true
    }
}


// WEBPACK FOOTER //
// ./src/components/Image.js